import React, {Component} from 'react';
import Pactilacel from '../Assets/Paclitaxel.jpg'
import Map from '../Assets/Map.jpg'

function BoldText({ children }) {
  return (
    <span style={{ fontWeight: 'bold' }}>{children}</span>
  );
}

function ItText({ children }) {
  return (
    <span style={{ fontStyle: 'italic', fontWeight: 'bold'  }}>{children}</span>
  );
}

class Papers extends Component {
    render() {
        return (
            <div>
                <section id="about1">
                    <div className="row">
                        <h2>Collection of research paper of Dr. Georgi Tosev</h2>
                        <p className="white">
<ul>
 
  <li><ItText>Urologists’ Estimation of Online Support Group Utilization Behavior
of Their Patients With Newly Diagnosed Nonmetastatic Prostate
Cancer in Germany: Predefined Secondary Analysis of a Randomized Controlled Trial. </ItText>
      Philipp Karschuck,  Christer Groeben,  Rainer Koch,  Tanja Krones,  Andreas Neisius,
 Sven von Ahn,  Christian Peter Klopf,  Steffen Weikert,  Michael Siebels,  Nicolas Haseke,
 Christian Weissflog,  Martin Baunacke,  Christian Thomas,  Peter Liske,  <BoldText>Georgi Tosev</BoldText>,
 Thomas Benusch,  Martin Schostak,  Joachim Stein,  Philipp Spiegelhalder, 
Andreas Ihrig,  Johannes Huber, Journal of Medical Reaserch, April 2025. </li>

 
  <li><ItText>Off-label Use of the Optilume Drug-coated Balloon in the Treatment of Bladder Neck Stenosis and Vesicourethral Anastomosis Stenosis. </ItText>
      <BoldText>Georgi Tosev</BoldText>, Ivan Damgov, Franklin Kuehhas, Hendrik Borgmann, Julian Struck, Johannes Salem, Timur H. Kuru,  
    European Urology Open Science Volume 75, May 2025, Pages 101-1058 </li>
 

  <li><ItText>Better Knowledge about Testicular Cancer Might Improve the Rate of Testicular (Self-)Examination: A Survey among 1,025 Medical Students in Germany. </ItText>
    Aksoy C, Ihrig A, Reimold P, <BoldText>Tosev G</BoldText>, Himmelsbach R, Jesser J, Babayigit G, Huber J. 
    Urol Int. 2022 Jul 28:1-5. doi: 10.1159/000525854. Online ahead of print. PMID: 35901778 </li>

  <li><ItText>Detection of PD-L1 in the urine of patients with urothelial carcinoma of the bladder. </ItText>
    <BoldText>Tosev G</BoldText>, Wahafu W, Reimold P, Damgov I, Schwab C, Aksoy C, Kaczorowski A, Stenzinger A, Nyarangi-Dix J, Hohenfellner M, Duensing S. 
    Sci Rep. 2021 Jul 9;11(1):14244. doi: 10.1038/s41598-021-93754-z. PMID: 34244564 </li>

  <li><ItText>Male fertility during and after immune checkpoint inhibitor therapy: A cross-sectional pilot study. </ItText>
    Salzmann M, <BoldText>Tosev G</BoldText>, Heck M, Schadendorf D, Maatouk I, Enk AH, Hartmann M, Hassel JC. 
    Eur J Cancer. 2021 Jul;152:41-48. doi: 10.1016/j.ejca.2021.04.031. Epub 2021 May 29. PMID: 34062486</li>

  <li><ItText>High prevalence of DNA damage repair gene defects and TP53 alterations in men with treatment-naïve metastatic prostate cancer - Results from a prospective pilot study using a 37 gene panel. </ItText>
    Nientiedt C, Endris V, Jenzer M, Mansour J, Sedehi NTP, Pecqueux C, Volckmar AL, Leichsenring J, Neumann O, Kirchner M, Hoveida S, Lantwin P, Kaltenecker K, Dieffenbacher S, Gasch C, Hofer L, Franke D, <BoldText>Tosev G</BoldText>, Görtz M, Schütz V, Radtke JP, Nyarangi-Dix J, Hatiboglu G, Simpfendörfer T, Schönberg G, Isaac S, Teber D, Koerber SA, Christofi G, Czink E, Kreuter R, Apostolidis L, Kratochwil C, Giesel F, Haberkorn U, Debus J, Sültmann H, Zschäbitz S, Jäger D, Duensing A, Schirmacher P, Grüllich C, Hohenfellner M, Stenzinger A, Duensing S.; Urol Oncol. 2020 Apr 10. pii: S1078-1439(20)30085-5. doi: 10.1016/j.urolonc.2020.03.001. [Epub ahead of print] PMID: 32280037</li>


  <li><ItText>The Value of Prostate-specific Antigen Density for Prostate Imaging-Reporting and Data System 3 Lesions on Multiparametric Magnetic Resonance Imaging: A Strategy to Avoid Unnecessary Prostate Biopsies.</ItText>
Görtz M, Radtke JP, Hatiboglu G, Schütz V, <BoldText>Tosev G</BoldText>, Güttlein M, Leichsenring J, Stenzinger A, Bonekamp D, Schlemmer HP, Hohenfellner M, Nyarangi-Dix JN.
Eur Urol Focus. 2019 Dec 12. pii: S2405-4569(19)30353-0. doi: 10.1016/j.euf.2019.11.012. PMID: 31839564</li>


  <li><ItText>Recovery of pad-free continence in elderly men does not differ from younger men undergoing robot-assisted radical prostatectomy for aggressive prostate cancer.</ItText>
Nyarangi-Dix JN, <BoldText>Tosev G</BoldText>, Damgov I, Reimold P, Aksoy C, Hatiboglu G, Teber D, Mansour J, Kuehhas FE, Radtke JP, Hohenfellner M.
World J Urol. 2020 Feb;38(2):351-360. doi: 10.1007/s00345-019-02797-5. Epub 2019 May 11.
PMID: 31079187</li>



  <li><ItText>Magnetic resonance imaging-guided transurethral ultrasound ablation of prostate tissue in patients with localized prostate cancer: single-center evaluation of 6-month treatment safety and functional outcomes of intensified treatment parameters.</ItText>
Hatiboglu G, Popeneciu V, Bonekamp D, Burtnyk M, Staruch R, Pahernik S, <BoldText>Tosev G</BoldText>, Radtke JP, Motsch J, Schlemmer HP, Hohenfellner M, Nyarangi-Dix JN.
World J Urol. 2020 Feb;38(2):343-350. doi: 10.1007/s00345-019-02784-w. Epub 2019 May 6.
PMID: 31062122</li>



  <li><ItText>Intracardiac Extension of Wilms Tumor: A Case of a 2.5-Year-Old Girl Presenting with Upper Venous Congestion Caused by Tumor Growth into the Right Cardiac Ventricle.</ItText>
Imle R, <BoldText>Tosev G</BoldText>, Behnisch W, Schenk JP, Rauch H, Mueller A, Gorenflo M, Loukanov T, Kulozik A, Nyarangi-Dix J.
Case Rep Oncol. 2019 Jan 4;12(1):33-38. doi: 10.1159/000496020. eCollection 2019 Jan-Apr.
PMID: 30792643</li>


  <li><ItText>Prostatic metastasis from intrahepatic cholangiocarcinoma.</ItText>
<BoldText>Tosev G</BoldText>, Schuetz V, Nyarangi-Dix J, Stenzinger A, Stoegbauer F, Kulu Y, Radtke JP, Teber D, Hatzinger M, Springfeld C, Koehler BC, Hohenfellner M.
Urol Case Rep. 2018 Jul 18;20:90-91. doi: 10.1016/j.eucr.2018.07.015. eCollection 2018 Sep. No abstract available.
PMID: 30101074</li>



  <li><ItText>Complete bladder neck preservation promotes long-term post-prostatectomy continence without compromising midterm oncological outcome: analysis of a randomised controlled cohort.</ItText>
Nyarangi-Dix JN, Tichy D, Hatiboglu G, Pahernik S, <BoldText>Tosev G</BoldText>, Hohenfellner M.
World J Urol. 2018 Mar;36(3):349-355. doi: 10.1007/s00345-017-2134-1. Epub 2017 Dec 6.
PMID: 29214353</li>


  <li><ItText>Paraganglioma of the Seminal Vesicle Case Report and Review of the Literature.</ItText>
<BoldText>Tosev G</BoldText>, Mendler M, Bergmann F, Klein T, Pahernik SA, Hadaschik BA, Hohenfellner M.
J Endourol Case Rep. 2016 Dec 1;2(1):227-231. doi: 10.1089/cren.2016.0119. eCollection 2016.
PMID: 28078324</li>



  <li><ItText>Primary melanoma of the prostate: case report and review of the literature.</ItText>
<BoldText>Tosev G</BoldText>, Kuru TH, Huber J, Freier G, Bergmann F, Hassel JC, Pahernik SA, Hohenfellner M, Hadaschik BA. BMC Urol. 2015 Jul 14;15:68. doi: 10.1186/s12894-015-0052-3. Review. PMID: 26169921</li>

  <li><ItText>Efficacy of targeted treatment beyond third-line therapy in metastatic kidney cancer: retrospective analysis from a large-volume cancer center.</ItText>
Vallet S, Pahernik S, Höfner T, <BoldText>Tosev G</BoldText>, Hadaschik B, Duensing S, Sedlaczek O, Hohenfellner M, Jäger D, Grüllich C; Renal Cancer Center at the National Center for Tumor Diseases (NCT) Heidelberg, Germany. Clin Genitourin Cancer. 2015 Jun;13(3):e145-52. doi: 10.1016/j.clgc.2014.12.012. Epub 2014 Dec 30.
PMID: 25596830</li>



  <li><ItText>Identification of cell-free microRNAs in the urine of patients with prostate cancer.</ItText>
Korzeniewski N, <BoldText>Tosev G</BoldText>, Pahernik S, Hadaschik B, Hohenfellner M, Duensing S.
Urol Oncol. 2015 Jan;33(1):16.e17-16.e22. doi: 10.1016/j.urolonc.2014.09.015. Epub 2014 Oct 23.
PMID: 25445383</li>



  <li><ItText>International multicentre psychometric evaluation of patient-reported outcome data for the treatment of Peyronie's disease.</ItText>
Kueronya V, Miernik A, Stupar S, Kojovic V, Hatzichristodoulou G, Egydio PH, <BoldText>Tosev G</BoldText>, Falcone M, De Luca F, Mulalic D, Djordjevic M, Schoenthaler M, Fahr C, Kuehhas FE.
BJU Int. 2015 May;115(5):822-8. doi: 10.1111/bju.12968.
PMID: 25327685</li>


  <li><ItText>Incidence of balanitis xerotica obliterans in boys younger than 10 years presenting with phimosis.</ItText>
Kuehhas FE, Miernik A, Weibl P, Schoenthaler M, Sevcenco S, Schauer I, <BoldText>Tosev G</BoldText>, Oezsoy M, Lassmann J. Urol Int. 2013;90(4):439-42. doi: 10.1159/000345442. Epub 2012 Dec 29.
PMID: 23296396</li>



  <li><ItText>Predictive power of objectivation of phimosis grade on outcomes of topical 0.1% betamethasone treatment of phimosis.</ItText>
Kuehhas FE, Miernik A, Sevcenco S, <BoldText>Tosev G</BoldText>, Weibl P, Schoenthaler M, Lassmann J.
Urology. 2012 Aug;80(2):412-6. doi: 10.1016/j.urology.2012.04.047. Epub 2012 Jun 29.
PMID: 22749426</li>


  <li><ItText>Multidetector computed tomography virtual cystoscopy: an effective diagnostic tool in patients with hematuria.</ItText>
Kuehhas FE, Weibl P, <BoldText>Tosev G</BoldText>, Schatzl G, Heinz-Peer G.
Urology. 2012 Feb;79(2):270-6. doi: 10.1016/j.urology.2011.10.011.
PMID: 22310741</li>



</ul>
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}

export default Papers;



// WEBPACK FOOTER //
// ./src/Components/Papers.js